import PostListComponent from '../../postAdmin/PostListComponent';

const PostsCustomer = () => {
  return <PostListComponent route="/customer/posts" />;
};

export default PostsCustomer;
